import DragHandle from 'nucleus-core/containers/DragHandle';
import Icon from '@cvent/nucleus-icon';
import InteractiveElement from 'nucleus-core/containers/InteractiveElement';
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { tapOrClick } from 'nucleus-core/touchEventHandlers';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';
const ZERO_WIDTH_SPACE = React.createElement(React.Fragment, null, "\u200B");
export default class DialogHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClose = (event) => {
            event.preventDefault();
            const { onClose } = this.props;
            if (onClose) {
                onClose();
            }
        };
    }
    render() {
        const { title, onClose, closeFallbackText, classes, style } = this.props;
        const closeButton = (React.createElement(InteractiveElement, Object.assign({}, resolve(this.props, 'closeDialog'), injectTestId('close'), { onClick: this.handleClose }, tapOrClick(this.selectItem)),
            React.createElement(Icon, { icon: "closeDeleteFilled", fallbackText: closeFallbackText })));
        return (React.createElement(DragHandle, { classes: classes, style: style, "aria-describedby": "dialogHeader" },
            React.createElement("div", Object.assign({}, resolve(this.props, 'dialogHeader'), resolveTestId(this.props), { id: "dialogHeader" }), !title || typeof title === 'string' ? (React.createElement("h2", Object.assign({}, resolve(this.props, 'title')),
                onClose && closeButton,
                title || ZERO_WIDTH_SPACE)) : (React.createElement("div", Object.assign({}, resolve(this.props, 'title')),
                onClose && closeButton,
                title)))));
    }
}
